module.exports = __webpack_public_path__ + "img/expovina_02.f60526a0.jpg";